import {AxiosResponse} from 'axios'
import {corporateApi} from '../../../../setup/axios/CorporateApi'
import {ApiResponse} from '../../../../shared/models/ApiModels'
import {ITagModel, ITagRequest} from './TagModel'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')
const TAG_URL = `${API_URL}api/v1/tag/`

/** withCounts: kaç adaya takılı olduğu da gelir (etiket ekranı) */
export function loadTags(withCounts = false): Promise<AxiosResponse<ApiResponse<ITagModel[]>>> {
  return corporateApi.get(`${TAG_URL}getAll`, {params: {withCounts}})
}

export function createTag(request: ITagRequest): Promise<AxiosResponse<ApiResponse<ITagModel>>> {
  return corporateApi.post(`${TAG_URL}create`, request)
}

export function updateTag(id: string, request: ITagRequest): Promise<AxiosResponse<ApiResponse<ITagModel>>> {
  return corporateApi.patch(`${TAG_URL}update/${id}`, request)
}

export function deleteTag(id: string) {
  return corporateApi.delete(`${TAG_URL}delete/${id}`)
}

/** Adayın etiketlerini verilen listeyle değiştirir (ekleme ve kaldırma) */
export function setCandidateTags(
  candidateId: string,
  tagIds: string[]
): Promise<AxiosResponse<ApiResponse<ITagModel[]>>> {
  return corporateApi.put(`${API_URL}api/v1/candidate/${candidateId}/tags`, {tagIds})
}
